<div class="mb-80">
    <mapfre-header></mapfre-header>
</div>
<div class="billing-stuffer-sec">
    <div class="billing-stuff-content">
        <div class="bs-slot">
            <div class="bs-banner billing-stuff-bg">
                    <div class="bs-title" *ngIf="!isPolicyAlreadyEnrolled">
                        <div>{{"Help us build a more"}}</div>
                        <div>{{"sustainable future!"}}</div>
                    </div>
            </div>
            <div class="bs-enroll-form">
                <mapfre-card [singleCard]="false">
                    <router-outlet></router-outlet>
                </mapfre-card>
            </div>
        </div>
    </div>
</div>